<template>
	<div>
		<div>
            <el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
                <!-- <el-form-item label="" prop="appid">
                    <app-list @getAppId="getAppId" :appId="formInline.appId" :clear="'noclear'"></app-list>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="success" icon="el-icon-circle-plus-outline" size="small" @click="addData">添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tableTh" v-height>
            <el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
                <el-table-column prop="" label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeType == 0">充值金币</span>
                        <span v-if="scope.row.rechargeType == 1">
                            {{scope.row.durationType==1?'月度会员':scope.row.durationType==4?'季度会员':scope.row.durationType==2?'年度会员':scope.row.durationType == 3 ? scope.row.days + '天会员' : ''}}
                        </span>
                        <!-- <span v-if="scope.row.rechargeType == 2">连续扣费会员</span> -->
                        <span v-if="scope.row.rechargeType == 3">单剧购买</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值金额">
                    <template slot-scope="scope">
                        <p>实付金额：{{scope.row.money}}</p>
                        <p>划线价：{{scope.row.originalPrice}}</p>
                        <p v-if="scope.row.rechargeType == 3">剧名：{{scope.row.videoName || '未指定'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="总金币数量" width="120">
                    <template slot-scope="scope">
                        <p>{{scope.row.rechargeType == 0 ? (scope.row.money * 10)*10 + scope.row.present : 0}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="rechargeInfo" label="充值说明"></el-table-column>
                <el-table-column prop="templateInfo" label="档位描述"></el-table-column>
                <el-table-column label="展示角标">
                    <template slot-scope="scope">
                        <div>
                            <span class="succes-text" v-if="scope.row.isShowSubscript == 1">已展示：{{scope.row.subscript}}</span>
                            <span class="danger-text"  v-if="scope.row.isShowSubscript == 0">未展示</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="orderNo" label="排序" width="80"></el-table-column>
                <el-table-column label="是否展示">
                    <template slot-scope="scope" class="ddd">
                        <div class="center">
                            <el-switch
                                    v-model="scope.row.isShow"
                                    active-color="#13ce66" disabled
                                    inactive-color="#ff4949" :active-value="1"
                                    :inactive-value="0">
                            </el-switch>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="350">
                    <template slot-scope="scope" class="ddd">
                        <el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row.id)">详情</el-button>
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
                        <el-popover width="160" :ref="scope.row.id" style="margin-left: 10px;">
                            <p class="popover-con del">
                                <i class="el-icon-question warnning-text"></i>确定删除吗？
                            </p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
                                <el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
                            </div>
                            <!-- :disabled="scope.row.isShow == 1 ? true : false" -->
                            <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :page-sizes="[20, 50, 100, 200, 500]"
                        :page-size="tableData.pageSize"
                        background
                        :current-page="currentPage"
                        layout="sizes, prev, pager, next, jumper, ->, total"
                        :total="tableData.totalNum">
                </el-pagination>
            </div>

        </div>
        <!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td width="200">充值类型</td>
					<td>
						<span v-if="ruleForm.rechargeType == 0">充值金币</span>
						<span v-if="ruleForm.rechargeType == 1">
                            {{ruleForm.durationType==1?'月度会员':ruleForm.durationType==4?'季度会员':ruleForm.durationType==2?'年度会员':ruleForm.durationType == 3 ? ruleForm.days + '天会员' :''}}
                        </span>
						<!-- <span v-if="ruleForm.rechargeType == 2">连续扣费会员</span> -->
						<span v-if="ruleForm.rechargeType == 3">单剧购买</span>
					</td>
				</tr>
				<tr>
					<td>充值金额</td>
					<td>
						<p>实付金额：{{ruleForm.money}}</p>
						<p>划线价：{{ruleForm.originalPrice}}</p>
						<p v-if="ruleForm.rechargeType == 3">剧名：{{ruleForm.videoName || '未指定'}}</p>
					</td>
				</tr>
				<tr>
					<td>总金币数量</td>
					<td>
						<p>{{ruleForm.rechargeType == 0 ? (ruleForm.money * 10)*10 + ruleForm.present : 0}}</p>
					</td>
				</tr>
				<tr>
					<td>充值说明</td>
					<td>
						<p>{{ruleForm.rechargeInfo}}</p>
					</td>
				</tr>
				<tr>
					<td>档位描述</td>
					<td>
						{{ruleForm.templateInfo}}
					</td>
				</tr>
				<tr>
					<td>展示角标</td>
					<td>
						<span class="succes-text" v-if="ruleForm.isShowSubscript == 1">已展示：{{ruleForm.subscript}}</span>
						<span class="danger-text"  v-if="ruleForm.isShowSubscript == 0">未展示</span>
					</td>
				</tr>
				<!-- <tr>
					<td>排序</td>
					<td>
						{{ruleForm.orderNo}}
					</td>
				</tr>
				<tr>
					<td>是否展示</td>
					<td>
						<el-switch
								v-model="ruleForm.isShow"
								active-color="#13ce66" disabled
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0">
						</el-switch>
					</td>
				</tr> -->
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
        <!--新增、编辑弹框-->
		<el-dialog :dialogTitle="dialogTitle" :visible.sync="dialogFormVisible" width="800px">
			<div style="position: relative;">
				<div class="cz-look">
					<i class="icon-text" v-if="ruleForm.subscript && ruleForm.isShowSubscript == 1" :style="'background:' + ruleForm.subscriptColour">{{ruleForm.subscript}}</i>
					<div class="cz-con">
						<p class="money" v-if="ruleForm.money"><span class="bold">￥{{ruleForm.money}}</span><del class="original">{{ruleForm.originalPrice}}</del></p>
						<p class="gold" v-if="ruleForm.rechargeInfo">{{ruleForm.rechargeInfo}}</p>
						<p class="song" v-if="ruleForm.templateInfo">{{ruleForm.templateInfo}}</p>
					</div>
				</div>
				<el-form :rules="rules" ref="ruleForm" :model="ruleForm" size="small" label-width="150px" class="input320" style="max-height: 480px;overflow: auto; padding-right: 20px;">
					<el-form-item label="充值类型：" prop="rechargeType">
						<el-select v-model="ruleForm.durationType" filterable clearable placeholder="请选择充值类型" @change="changeRechargeType">
							<el-option
                                v-for="item in durationTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="指定短剧：" prop="videoId" v-if="ruleForm.durationType==-1">
                        <el-tag closable @close="handleCloseTagVideo" v-if="ruleForm.svName" style="margin-right: 10px;">{{ruleForm.svName}}</el-tag>
                        <el-button type="primary" size="small" @click="isShowDialogVideo = true">选择</el-button>
                        <el-input v-model="ruleForm.aliasName" style="display: none;"></el-input>
                        <el-input v-model="ruleForm.strategyId" style="display: none;"></el-input>
                    </el-form-item>
					<el-form-item label="实付金额：" prop="money">
						<el-input type="number" v-model="ruleForm.money" placeholder="请输入实付金额，单位是元"></el-input>
						<p class="input-note">1元 = 100金币</p>
					</el-form-item>
					<el-form-item label="划线价：">
						<el-input type="number" v-model="ruleForm.originalPrice" placeholder="请输入划线价"></el-input>
					</el-form-item>
					<el-form-item label="赠币数量：" v-if="ruleForm.rechargeType == 0">
						<el-input type="number" v-model="ruleForm.present" placeholder="请输入赠币数量"></el-input>
					</el-form-item>
                    <el-form-item label="会员天数：" v-if="ruleForm.rechargeType == 1 && ruleForm.durationType == 3">
						<el-input type="number" v-model="ruleForm.days" placeholder="请输入会员天数"></el-input>
					</el-form-item>
					<el-form-item label="充值说明：" prop="rechargeInfo">
						<el-input v-model="ruleForm.rechargeInfo" placeholder="请输入充值说明"></el-input>
						<p class="input-note">建议：类型为金币填XX金币+XX赠币，会员自由填写</p>
					</el-form-item>
					<el-form-item label="档位描述：" prop="templateInfo">
						<el-input v-model="ruleForm.templateInfo" placeholder="请输入实付金额，单位是元"></el-input>
						<p class="input-note">建议：多送X元、XX元/天、解锁全剧等</p>
					</el-form-item>
					<el-form-item label="展示角标：">
						<el-switch
								v-model="ruleForm.isShowSubscript"
								active-color="#13ce66"
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0">
						</el-switch>
					</el-form-item>
					<el-form-item label="角标文案：" prop="subscript" v-if="ruleForm.isShowSubscript == 1">
						<el-input v-model="ruleForm.subscript" placeholder="请输入角标文案" style="width: 180px; float: left;"></el-input>
						<div class="block" style="display: inline-block; float: left; margin-left: 15px; height: 32px;">
							<el-color-picker v-model="ruleForm.subscriptColour"></el-color-picker>
						</div>
					</el-form-item>
					<el-form-item label="档位高亮色：">
						<el-switch
                            v-model="ruleForm.isShowHighLight"
                            active-color="#13ce66"
                            inactive-color="#ff4949" :active-value="1"
                            :disabled="ruleForm.rechargeType == 1"
                            :inactive-value="0">
						</el-switch>
						<span style="margin-left: 10px; font-size: 12px; color: #999;">开启后，金币类型档位底色展示黄色渐变样式，会员类型默认开启</span>
					</el-form-item>
					<!-- <el-form-item label="排序：" prop="orderNo">
						<el-input v-model="ruleForm.orderNo"></el-input>
					</el-form-item>
					<el-form-item label="是否展示：">
						<el-switch
								v-model="ruleForm.isShow"
								active-color="#13ce66"
								inactive-color="#ff4949" :active-value="1"
								:inactive-value="0">
						</el-switch>
						<span style="margin-left: 10px; font-size: 12px; color: #999;">开启后，充值档位会展示在小程序上</span>
					</el-form-item> -->
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
        <video-table :visible.sync="isShowDialogVideo" :appId="formInline.appId" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo"></video-table>
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import VideoTable from '@/components/VideoTable';
import {gearList, gearDetails, gearAdd, gearDel,} from "@/api/dysvzk/agentmenu/recharge";
export default {
    name: 'AgentRechargeGear',
    components: {
		// AppList,
		VideoTable,
	},
    data() {
        return {
            formInline: {
				appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
			},
            currentPage: 1,
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            ruleForm:{
                id: '',
				appId: '',
				change: 'add',
                durationType:'',
                isShow:1,
                isShowHighLight:0,
                isShowSubscript:1,
                money:'',
                orderNo:'',
                originalPrice:'',
                present:'',
                rechargeInfo:'',
                rechargeType:'',
                subscript:'',
                subscriptColour:'',
                templateInfo:'',
                videoId:'',
                updateType: '',
                days:'',//会员天数
            },
            dialogFormVisible:false,
            dialogTitle:'',
            rules:{
                durationType: [
					{required: true, message: '请选择充值类型', trigger: 'change'}
				],
                money: [
                    {required: true, message: '请输入实付金额', trigger: 'blur'},
                    // { validator: validateNum, trigger: 'blur' }
                ],
                rechargeInfo: [
					{required: true, message: '请输入充值说明', trigger: 'change'}
				],
				orderNo: [
					{required: true, message: '请输入排序', trigger: 'blur'},
					// { validator: validateNum, trigger: 'blur' }
				],
                subscript:[
                    {required: true, message: '请输入角标文案', trigger: 'blur'},
                ]
            },
            dialogInfoVisible:false,
            durationTypeOptions: [ // 类型
				{
					value: 0,
					label: '充值金币'
				},
                {
                    value: 1,
                    label: '月度会员'
                },
                {
                    value: 4,
                    label: '季度会员'
                },
                {
                    value: 2,
                    label: '年度会员'
                },
                {
                    value: -1,
                    label: '单剧购买(代理商专属)'
                },
                {
                    value: 3,
                    label: '自定义会员'
                },
			],
            isShowDialogVideo:false,
            selectVideo: {},
            isHighDisabled:false,
        }
    },
    computed: {},
    watch: {
    },
    mounted: function() {
        this.getTableData()
    },
    methods: {
        //添加
        addData(){
            console.log("添加")
            if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
            this.dialogFormVisible = true
            this.dialogTitle = '添加充值档位'
            this.ruleForm = {
                id: '',
				appId: this.formInline.appId,
				change: 'add',
                durationType:'',
                isShow:1,
                isShowHighLight:0,
                isShowSubscript:1,
                money:'',
                orderNo:'',
                originalPrice:'',
                present:'',
                rechargeInfo:'',
                rechargeType:'',
                subscript:'',
                subscriptColour:'#FF4640',
                templateInfo:'',
                videoId:'',
                updateType: "add",
                days:'',//会员天数
            }
            this.selectVideo = {}
        },
        //详情
        handleLook(id) {
			this.dialogInfoVisible = true
            this.getDetails(id)
		},
        //获取详情
        getDetails(id) {
            gearDetails({
				id: id
			}).then(response => {
                if (response.data.head.flag === 0) {
                    this.ruleForm = response.data.content
					this.ruleForm.change = 'upd'
                    this.ruleForm.updateType = 'edit'
                    this.ruleForm.svId = response.data.content.videoId
                    this.ruleForm.svName = response.data.content.videoName
                    if(response.data.content.rechargeType == 3){
                        this.ruleForm.durationType = -1
                    }
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });  
		},
        // 编辑
		handleEdit(id) {
            console.log("-编辑---",this.$refs['ruleForm'])
			// if (this.$refs['ruleForm'] !== undefined) {
			// 	this.$refs['ruleForm'].resetFields()
			// }
            this.dialogTitle = '编辑充值档位'
            this.dialogFormVisible = true
            this.getDetails(id)
		},
        // 删除
        handleDelete(id) {
            gearDel({
                id: id,
            }).then(response => {
                if (response.data.head.flag === 0) {
                    if (this.tableData.result.length === 1 && this.currentPage > 1) {
                        this.currentPage =  this.currentPage - 1
                    }
                    this.$refs[id].doClose()
                    this.getTableData(this.tabValue)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
        },
        //确定保存
        editDialogSureBtn(formName){
            this.$refs[formName].validate((valid) => {
				if (valid) {
					this.saveTableData('add')
				} else {
					console.log('error submit!!');
					return false;
				}
			});
        },
        // 保存编辑信息
		saveTableData () {
			console.log(this.ruleForm)
            // let json3 = {
            //     appId: this.formInline.appId
            // };
            // let json4 = this.ruleForm;
            // let paramJson1 = { ...json3, ...json4 }
            if(this.ruleForm.durationType == -1){
                this.ruleForm.durationType = 0
            }
            const info = {
                id: this.ruleForm.id || '',
				appId: this.formInline.appId || '',
				change: this.ruleForm.change,
                durationType:this.ruleForm.durationType,
                isShow:this.ruleForm.isShow,
                isShowHighLight:this.ruleForm.isShowHighLight,
                isShowSubscript:this.ruleForm.isShowSubscript,
                money:this.ruleForm.money || '',
                orderNo:this.ruleForm.orderNo || '',
                originalPrice:this.ruleForm.originalPrice || '',
                present:this.ruleForm.present || '',
                rechargeInfo:this.ruleForm.rechargeInfo || '',
                rechargeType:this.ruleForm.rechargeType,
                subscript:this.ruleForm.subscript || '',
                subscriptColour:this.ruleForm.subscriptColour || '',
                templateInfo:this.ruleForm.templateInfo || '',
                videoId:this.ruleForm.videoId || '',
                updateType: this.ruleForm.updateType,
                days: this.ruleForm.days || '',
            }

            gearAdd(info).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.getTableData()
                    this.dialogFormVisible = false
                } else {
                    this.$message.error(response.data.head.desc);
                }
            })
			
		},
        //获取列表
        getTableData() {
            let json2 = {
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            console.log("paramJson",paramJson)
            gearList(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        handleCurrentChange(value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.tableData.pageSize  = val
            this.currentPage = 1
            this.getTableData()
        },
        // 从组件获取appid
		// getAppId(data) {
		// 	this.formInline.appId = data
		// 	this.getTableData()
		// },
        // 确定剧
		videoSure(data) {
			console.log(data)
			this.ruleForm.svName = data.videolistVo.svName
			this.ruleForm.aliasName = data.videolistVo.aliasName
            this.ruleForm.strategyId = data.id
			this.ruleForm.videoId = data.svId
			this.selectVideo = data
		},
        // 删除所选剧
		handleCloseTagVideo(tag){
            console.log(tag)
            this.ruleForm.svName = ''
            this.ruleForm.svId = ''
            this.ruleForm.videoId = ''
            this.selectVideo = {}
            // this.ruleForm.unlockInfoVo[0].startEpNumber = ''
        },
        // 关闭选剧弹窗
		cancelDialogVideo(data) {
			// console.log('cancel')
			this.isShowDialogVideo = data
		},

        //添加档位-选择充值类型
        changeRechargeType(val){
            if(val == 1 || val == 2 || val == 4 || val == 3){
                this.ruleForm.isShowHighLight = 1;
                this.isHighDisabled = true
            }else{
                this.ruleForm.isShowHighLight = 0;
                this.isHighDisabled = false
            }

            if(val == 1 || val == 2 || val == 4 || val == 3){
                this.ruleForm.rechargeType = 1
            }else if(val == -1){
                this.ruleForm.rechargeType = 3
            }else{
                this.ruleForm.rechargeType = 0
            }

        }
    }
}
</script>
<style lang="scss">
    .tableTh{
        margin-top: 16px;
    }
    .cz-look{
		position: absolute;
		top: 5px;
		right: 60px;
		width: 160px;
		height: 110px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #eee;
		border-radius: 10px;
		.icon-text{
			position: absolute;
			right: -5px;
			top: -5px;
			padding: 5px 8px;
			background: #FF7368;
			color: #fff;
			border-radius: 15px 15px 15px 0;
			font-style: normal;
			font-size: 12px;
		}
		.cz-con{
			display: inline-block;
			text-align: center;
		}
		.money{
			margin-bottom: 10px;
			.bold{
				font-size: 16px;
				font-weight: bold;
				color: #101010;
			}
			.original{
				font-size: 12px;
				color: #9B988D;
				margin-left: 5px;
			}
		}
		.gold{
			font-size: 14px;
			margin-bottom: 10px;
			color: #21201D;
		}
		.song{
			color: #EA7939;
			font-size: 14px;
		}
	}
</style>
